import { render, staticRenderFns } from "./BostonPage.vue?vue&type=template&id=c5af7796&scoped=true"
import script from "./BostonPage.vue?vue&type=script&lang=js"
export * from "./BostonPage.vue?vue&type=script&lang=js"
import style0 from "./BostonPage.vue?vue&type=style&index=0&id=c5af7796&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5af7796",
  null
  
)

export default component.exports